
document.addEventListener('DOMContentLoaded', function () {

  /* =========================
     MOST LOVED SLIDER
  ========================== */
  // if (document.querySelector('.mostlove-swiper')) {
    // new Swiper('.mostlove-swiper', {
    //   slidesPerView: 4,
    //   spaceBetween: 0,
    //   freeMode: true,

    //   navigation: {
    //     nextEl: '.mostlove-next',
    //     prevEl: '.mostlove-prev'
    //   },

    //   pagination: {
    //     el: '.mostlove-swiper .swiper-pagination',
    //     type: 'progressbar'
    //   },

    //   breakpoints: {
    //     0: {
    //       slidesPerView: 2,
    //       spaceBetween: 10
    //     },
    //     768: {
    //       slidesPerView: 3,
    //       spaceBetween: 20
    //     },
    //   }
    // });


    // let mostloveSwiper;

        // function toggleMostloveSwiper() {
        //   const slider = document.querySelector('.mostlove-swiper');

        //   if (!slider) return;

        //   if (window.innerWidth > 767) {

        //     if (!mostloveSwiper) {
        //       mostloveSwiper = new Swiper('.mostlove-swiper', {
        //         slidesPerView: 4,
        //         spaceBetween: 20,
        //         navigation: {
        //           nextEl: '.mostlove-next',
        //           prevEl: '.mostlove-prev',
        //         },
        //         pagination: {
        //           el: '.mostlove-swiper .swiper-pagination',
        //           type: 'progressbar'
        //         },
        //         breakpoints: {
        //           992: { slidesPerView: 4 },
        //           767: { slidesPerView: 3 }
        //         }
        //       });
        //     }

        //   } else {

        //     if (mostloveSwiper) {
        //       mostloveSwiper.destroy(true, true);
        //       mostloveSwiper = null;
        //     }

        //   }
        // }
        



  //     toggleMostloveSwiper();
  //     window.addEventListener('resize', toggleMostloveSwiper);

  // }
  // -----------------present ---------------------------------
// if (document.querySelector('.mostlove-swiper')) {

//   let mostloveSwiper;

//   function toggleMostloveSwiper() {
//     const slider = document.querySelector('.mostlove-swiper');
//     if (!slider) return;

//     if (window.innerWidth > 767) {
//       if (!mostloveSwiper) {

//         // Read totalReal from a data attribute on the slider element
//         const totalReal = parseInt(slider.getAttribute('data-total')) || 4;

//         mostloveSwiper = new Swiper('.mostlove-swiper', {
//           slidesPerView: 4,
//           spaceBetween: 20,
//           loop: true,
//           loopedSlides: totalReal,
//           watchSlidesProgress: true,
//           navigation: {
//             nextEl: '.mostlove-next',
//             prevEl: '.mostlove-prev',
//           },
//           pagination: {
//             el: '.mostlove-swiper .swiper-pagination',
//             type: 'progressbar'
//           },
//           breakpoints: {
//             992: { slidesPerView: 4 },
//             767: { slidesPerView: 3 }
//           }
//         });
//       }

//     } else {
//       if (mostloveSwiper) {
//         mostloveSwiper.destroy(true, true);
//         mostloveSwiper = null;
//       }
//     }
//   }

//   toggleMostloveSwiper();
//   window.addEventListener('resize', toggleMostloveSwiper);
// }
// present-------------------------------------------------------------------------------

if (document.querySelector('.mostlove-swiper')) {

  let mostloveSwiper;

  function updateProgressBar(swiper, totalReal) {
    const progressEl = swiper.el.querySelector('.swiper-pagination-progressbar-fill');
    if (!progressEl) return;

    // Calculate progress within a cycle of totalReal slides
    const progress = ((swiper.realIndex % totalReal) + 1) / totalReal;
    progressEl.style.transform = `scaleX(${progress})`;
  }

  function toggleMostloveSwiper() {
    const slider = document.querySelector('.mostlove-swiper');
    if (!slider) return;

    if (window.innerWidth > 767) {
      if (!mostloveSwiper) {
        const totalReal = parseInt(slider.getAttribute('data-total')) || 4;

        mostloveSwiper = new Swiper('.mostlove-swiper', {
          slidesPerView: 4,
          spaceBetween: 20,
          loop: true,
          loopedSlides: totalReal,
          watchSlidesProgress: true,
          navigation: {
            nextEl: '.mostlove-next',
            prevEl: '.mostlove-prev',
          },
          pagination: {
            el: '.mostlove-swiper .swiper-pagination',
            type: 'progressbar',
            renderProgressbar: function (progressbarFillClass) {
              return '<span class="' + progressbarFillClass + '"></span>';
            }
          },
          breakpoints: {
            992: { slidesPerView: 4 },
            767: { slidesPerView: 3 }
          },
          on: {
            init: function () {
              updateProgressBar(this, totalReal);
            },
            slideChange: function () {
              updateProgressBar(this, totalReal);
            }
          }
        });
      }

    } else {
      if (mostloveSwiper) {
        mostloveSwiper.destroy(true, true);
        mostloveSwiper = null;
      }
    }
  }

  toggleMostloveSwiper();
  window.addEventListener('resize', toggleMostloveSwiper);
}
  /* =========================
     REVIEW SLIDER
  ========================== */
  // if (document.querySelector('.review-swiper')) {
  //   new Swiper('.review-swiper', {
  //     slidesPerView: 1,
  //     spaceBetween: 20,
  //     loop: true,
  //     autoplay: false,


  //     pagination: {
  //       el: '.review-swiper .swiper-pagination',
  //       clickable: true
  //     },

  //     navigation: {
  //       nextEl: '.review-swiper .swiper-button-next',
  //       prevEl: '.review-swiper .swiper-button-prev'
  //     }
  //   });
  // }

//   if (document.querySelector('.review-swiper')) {
//   new Swiper('.review-swiper', {
//     slidesPerView: 1,
//     spaceBetween: 20,
//     loop: true,
//     grabCursor: true,

//     pagination: {
//       el: '.review-swiper .swiper-pagination',
//       clickable: true
//     },

//     navigation: {
//       nextEl: '.slider-buttons .swiper-button-next',
//       prevEl: '.slider-buttons .swiper-button-prev'
//     }
//   });
// }




  const reviewSlider = document.querySelector('.review-swiper');

  if (reviewSlider) {
    new Swiper(reviewSlider, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      grabCursor: true,
      watchOverflow: true,

      pagination: {
        el: reviewSlider.querySelector('.swiper-pagination'),
        clickable: true
      },

      navigation: {
        nextEl: document.querySelector('.slider-buttons .swiper-button-next'),
        prevEl: document.querySelector('.slider-buttons .swiper-button-prev')
      }
    });
  }





  /* =========================
     HEROMESH SLIDER
  ========================== */
  if (document.querySelector('.heromesh-swiper')) {
    new Swiper('.heromesh-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      autoplay: false,

      navigation: {
        nextEl: '.heromesh-swiper .swiper-button-next',
        prevEl: '.heromesh-swiper .swiper-button-prev'
      }
    });
  }

if (document.querySelector('.means-health-swiper')) {
  var meansSwiper = new Swiper('.means-health-swiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});


}

if (document.querySelector('.deserve-better-swiper')) {

// var deserveSwiper = new Swiper('.deserve-better-swiper', {
//   slidesPerView: 1,
//   spaceBetween: 14,
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   }
// });

// var deserveSwiper = new Swiper('.deserve-better-swiper', {
//   slidesPerView: 1,
//   spaceBetween: 16,
//   loop: true,
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   },
//   autoHeight: true
// });


// Working one...
// var deserveSwiper = new Swiper('.deserve-better-swiper', {
//   slidesPerView: 1.2,
//   spaceBetween: 16,
//   autoHeight: true,
//   loop:true,
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   }
// });



// // TAB CLICK → MOVE SLIDER TO FIRST MATCHING REVIEW
// document.querySelectorAll('.bh-tabs .nav-link').forEach(function(tabBtn) {
//   tabBtn.addEventListener('click', function() {

//     if (window.innerWidth > 767) return;

//     var tabKey = this.getAttribute('data-tab');
//     var slides = document.querySelectorAll('.deserve-better-swiper .swiper-slide');

//     for (var i = 0; i < slides.length; i++) {
//       if (slides[i].dataset.tab === tabKey) {
//         deserveSwiper.slideTo(i);
//         break;
//       }
//     }
//   });
// });



var deserveSwiper = new Swiper('.deserve-better-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 16,
  autoHeight: true,
  loop: false,

  pagination: {
    el: '.deserve-better-swiper .swiper-pagination',
    clickable: true
  },

  on: {
    slideChange: function () {
      fixPagination(this);
    }
  }
});


// TAB CLICK → MOVE SLIDER TO FIRST MATCHING REVIEW
document.querySelectorAll('.bh-tabs .nav-link').forEach(function(tabBtn) {
  tabBtn.addEventListener('click', function() {

    if (window.innerWidth > 767) return;

    var tabKey = this.getAttribute('data-tab');
    var slides = document.querySelectorAll('.deserve-better-swiper .swiper-slide');

    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.tab === tabKey) {
        deserveSwiper.slideTo(i);
        setTimeout(() => fixPagination(deserveSwiper), 50);
        break;
      }
    }
  });
});


// FORCE ACTIVE BULLET SYNC (MODULO FIX)
function fixPagination(swiper) {
  var bullets = document.querySelectorAll('.deserve-better-swiper .swiper-pagination-bullet');

  bullets.forEach(b => b.classList.remove('swiper-pagination-bullet-active'));

  var activeIndex = swiper.realIndex % 3;

  if (bullets[activeIndex]) {
    bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
  }
}

}

});



document.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('.sizeclose');
  if (!closeBtn) return;

  e.preventDefault();

  const modal = document.querySelector(
    '.modal-dialog.sizing-chart-modal[open]'
  );
  if (!modal) return;

  /* Close modal */
  modal.removeAttribute('open');

  /* Restore scroll */
  document.body.classList.remove('overflow-hidden', 'modal-open');
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';

  /* Remove Shopify backdrop */
  const backdrop = document.querySelector('.product-popup-modal__overlay');
  if (backdrop) backdrop.remove();
});




// Fair manufacturing...
// document.addEventListener('DOMContentLoaded', function () {

//   let fairSwiper;

//   function toggleFairSwiper() {
//     const slider = document.querySelector('.fair-manufacturing-swiper');

//     if (window.innerWidth <= 767) {
//       slider.classList.add('swiper');

//       if (!fairSwiper) {
//         fairSwiper = new Swiper('.fair-manufacturing-swiper', {
//           slidesPerView: 1.40,
//           spaceBetween: 0,
//           centeredSlides: true,
//           grabCursor: true,
//           loop: true,
//           pagination: {
//             el: '.fair-manufacturing-swiper .swiper-pagination',
//             clickable: true
//           }
//         });
//       }

//     } else {
//       slider.classList.remove('swiper');

//       if (fairSwiper) {
//         fairSwiper.destroy(true, true);
//         fairSwiper = null;
//       }
//     }
//   }

//   toggleFairSwiper();
//   window.addEventListener('resize', toggleFairSwiper);

// });


document.addEventListener('DOMContentLoaded', function () {

  const fairSwiper = new Swiper('.fair-manufacturing-swiper', {
    loop: true,
    centeredSlides: true,
    grabCursor: true,
    spaceBetween:0,
    slidesPerView: "auto",   // 👈 important change

    breakpoints: {
      769: {
        slidesPerView: 4,
        centeredSlides: false,
        loop: false
      }
    },

    pagination: {
      el: '.fair-pagination',
      clickable: true
    }
  });

});







// Four reasons...

document.addEventListener('DOMContentLoaded', function () {

  let buildSwiper;

  function toggleBuildSwiper() {
    const slider = document.querySelector('.build-swiper');

    if (!slider) return;

    if (window.innerWidth <= 768) {

      slider.classList.add('swiper');

      if (!buildSwiper) {
        buildSwiper = new Swiper('.build-swiper', {
          slidesPerView: 1,
          spaceBetween: 15,
          autoHeight: true,

          pagination: {
            el: '.build-pagination',
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>';
            }
          }
        });
      }

    } else {

      slider.classList.remove('swiper');

      if (buildSwiper) {
        buildSwiper.destroy(true, true);
        buildSwiper = null;
      }

    }
  }

  toggleBuildSwiper();
  window.addEventListener('resize', toggleBuildSwiper);

});


// ---------------size close button -----------------------------------------
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.sizeclose')) return;

        e.preventDefault();

        const modal = document.querySelector('modal-dialog.sizing-chart-modal[open]');

        if (!modal) return;

        /* 1️⃣ Close modal visually */
        modal.removeAttribute('open');

        /* 2️⃣ CRITICAL: restore page scroll & interaction */
        document.body.classList.remove('overflow-hidden', 'modal-open');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';

        /* 3️⃣ Remove focus trap leftovers (Shopify) */
        const backdrop = document.querySelector('.product-popup-modal__overlay');
        if (backdrop) backdrop.remove();
      });
   

  // ------------------slider --------------------------------
  if (typeof jQuery !== "undefined" && typeof jQuery.fn.slick !== "undefined") {

      function initMobileSlider() {
        if (window.innerWidth <= 767) {
          if (!$('.main_3').hasClass('slick-initialized')) {
            $('.main_3').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              infinite: false,
              adaptiveHeight: true,
            });
          }
        } else {
          if ($('.main_3').hasClass('slick-initialized')) {
            $('.main_3').slick('unslick');
          }
        }
      }

      $(document).ready(function () {
        initMobileSlider();
      });

      $(window).on('resize', function () {
        initMobileSlider();
      });
    }
 // ----------------------------------------------------------------------------------------

// async function applyCoupon(code) {
//   try {
//     // Apply discount
//     await fetch(`/discount/${code}`);

//     // Get updated cart
//     const res = await fetch('/cart.js');
//     const cart = await res.json();

//     updateCartUI(cart);
//   } catch (err) {
//     console.error(err);
//   }
// }
// async function removeCoupon() {
//   try {
//     await fetch('/discount/'); // clears discount

//     const res = await fetch('/cart.js');
//     const cart = await res.json();

//     updateCartUI(cart);
//   } catch (err) {
//     console.error(err);
//   }
// }
// if (typeof Shopify === 'undefined') {
//   window.Shopify = {};
// }

// Shopify.formatMoney = function(cents, format) {

//   if (typeof cents === 'string') {
//     cents = cents.replace('.', '');
//   }

//   let value = '';

//   const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

//   const formatString = format || "₹{{amount}}";

//   function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {

//     if (isNaN(number) || number == null) {
//       return 0;
//     }

//     number = (number / 100.0).toFixed(precision);

//     const parts = number.split('.');

//     const dollarsAmount =
//       parts[0].replace(
//         /(\d)(?=(\d\d\d)+(?!\d))/g,
//         "$1" + thousands
//       );

//     const centsAmount = parts[1] ? decimal + parts[1] : '';

//     return dollarsAmount + centsAmount;

//   }

//   value = formatString.replace(placeholderRegex, function(match, key) {

//     switch (key) {

//       case 'amount':

//         return formatWithDelimiters(cents, 2);

//       default:

//         return formatWithDelimiters(cents, 2);

//     }

//   });

//   return value;

// };


// window.handleDiscountForm = async function(e) {

//   e.preventDefault();

//   const input = document.getElementById('CartDiscountInput');

//   const code = input.value.trim();

//   if (!code) return;

//   await fetch(`/discount/${code}?redirect=/cart`);

//   await refreshCartDiscount();

// };
// window.handleDiscountForm = async function(e) {

//   e.preventDefault();

//   const code =
//     document.getElementById('CartDiscountInput').value.trim();

//   if (!code) return;

//   await fetch(`/discount/${code}?redirect=/cart`, {
//     method: 'GET',
//     credentials: 'same-origin'
//   });

//   await new Promise(resolve => setTimeout(resolve, 300));

//   await refreshCartDiscount();

// };
// window.handleDiscountForm = async function(e) {

//   e.preventDefault();

//   const code =
//     document.getElementById('CartDiscountInput').value.trim();

//   if (!code) return;

//   await fetch(`/discount/${code}?redirect=/cart`, {
//     method: 'GET',
//     credentials: 'same-origin',
//     cache: 'no-store'
//   });

//   await new Promise(resolve => setTimeout(resolve, 400));

//   await refreshCartDiscount();

// };
// window.handleDiscountForm = async function(e) {

//   e.preventDefault();

//   const code =
//     document.getElementById('CartDiscountInput').value.trim();

//   if (!code) return;

//   await fetch(`/checkout?discount=${code}`, {
//     method: 'GET',
//     credentials: 'same-origin'
//   });

//   await new Promise(resolve => setTimeout(resolve, 500));

//   await refreshCartDiscount();

// };


// window.removeDiscount = async function() {

//   await fetch(`/discount/?redirect=/cart`);

//   await refreshCartDiscount();

// };
// window.removeDiscount = async function() {

//   try {

//     /* Call cart endpoint to clear discount */

//     await fetch('/cart?discount=', {
//       method: 'GET',
//       credentials: 'same-origin'
//     });

//     /* Wait for Shopify to update cookie/session */

//     await new Promise(resolve => setTimeout(resolve, 300));

//     /* Refresh cart UI */

//     await refreshCartDiscount();

//   }

//   catch (e) {

//     console.error("Remove discount failed", e);

//   }

// };
// window.removeDiscount = async function() {

//   try {

//     /* Clear checkout discount session */

//     await fetch('/checkout?discount=', {
//       method: 'GET',
//       credentials: 'same-origin'
//     });

//     /* wait for cookie update */

//     await new Promise(resolve => setTimeout(resolve, 500));

//     /* Now refresh cart */

//     await refreshCartDiscount();

//   }

//   catch(e) {

//     console.error(e);

//   }

// };


// async function refreshCartDiscount() {

//   const res = await fetch('/cart.js');

//   const cart = await res.json();

//   const badge = document.getElementById('CartDiscountBadge');

//   const badgeText = document.getElementById('AppliedDiscountCode');

//   /* ---------------- */
//   /* Badge update */
//   /* ---------------- */

//   if (cart.cart_level_discount_applications.length > 0) {

//     const discount = cart.cart_level_discount_applications[0];

//     badge.style.display = "flex";

//     badgeText.textContent =
//       `${discount.title} (-${Shopify.formatMoney(cart.total_discount)})`;

//   }

//   else {

//     badge.style.display = "none";

//     badgeText.textContent = "";

//   }


//   /* ---------------- */
//   /* Totals update */
//   /* ---------------- */

//   const subtotalEl = document.querySelector('.subtotal');
//   const discountEl = document.querySelector('.discount');
//   const totalEl = document.querySelector('.total');
//   const discountRow = document.querySelector('.discount-row');

//   if (subtotalEl)
//     subtotalEl.textContent =
//       Shopify.formatMoney(cart.original_total_price);

//   if (discountEl)
//     discountEl.textContent =
//       Shopify.formatMoney(cart.total_discount);

//   if (totalEl)
//     totalEl.textContent =
//       Shopify.formatMoney(cart.total_price);


//   if (discountRow)
//     discountRow.style.display =
//       cart.total_discount > 0 ? "flex" : "none";

// }

// document.addEventListener("DOMContentLoaded", refreshCartDiscount);

// // function updateCartUI(cart) {
// //   document.querySelector('.subtotal').textContent =
// //     Shopify.formatMoney(cart.original_total_price);

// //   document.querySelector('.discount').textContent =
// //     Shopify.formatMoney(cart.total_discount);

// //   document.querySelector('.total').textContent =
// //     Shopify.formatMoney(cart.total_price);

// //   // Show/hide discount block
// //   if (cart.total_discount > 0) {
// //     document.querySelector('.discount-row').style.display = 'block';
// //   } else {
// //     document.querySelector('.discount-row').style.display = 'none';
// //   }
// // }
// document.addEventListener("visibilitychange", function() {

//   if (document.visibilityState === "visible") {

//     refreshCartDiscount();

//   }

// });

// ----------------------------------------------------

// document.addEventListener("DOMContentLoaded", function () {
//   const sidebar = document.querySelector(".sticky-card");
//   const sidebarContainer = document.querySelector(".side_bar");
//   const offerBox = document.querySelector(".sticky-till-here");

//   if (!sidebar || !sidebarContainer || !offerBox) return;

//   const topOffset = 100; // space from top when fixed

//   function updateSidebar() {
//     const scrollY = window.scrollY;

//     const containerTop = sidebarContainer.offsetTop;
//     const containerHeight = sidebarContainer.offsetHeight;

//     const offerTop = offerBox.offsetTop;

//     const sidebarHeight = sidebar.offsetHeight;

//     const startFix = containerTop - topOffset;
//     const stopFix = offerTop - sidebarHeight - topOffset;

//     // 1️⃣ Before reaching sidebar
//     if (scrollY < startFix) {
//       sidebar.style.position = "static";
//       sidebar.style.top = "auto";
//       sidebar.style.width = "100%";
//     }

//     // 2️⃣ While scrolling (fixed state)
//     else if (scrollY >= startFix && scrollY < stopFix) {
//       sidebar.style.position = "fixed";
//       sidebar.style.top = topOffset + "px";
//       sidebar.style.width = sidebarContainer.offsetWidth + "px";
//     }

//     // 3️⃣ When reaching offer_box (stop state)
//     else {
//       sidebar.style.position = "absolute";
//       sidebar.style.top =
//         offerTop - containerTop - sidebarHeight + "px";
//       sidebar.style.width = "100%";
//     }
//   }

//   window.addEventListener("scroll", updateSidebar);
//   window.addEventListener("resize", updateSidebar);

//   updateSidebar(); // run once on load
// });
// document.addEventListener("DOMContentLoaded", function () {
//   const sidebar = document.querySelector(".sticky-card");
//   const stopElement = document.querySelector(".sticky-till-here");

//   if (!sidebar || !stopElement) return;

//   const topOffset = 100;

//   function updateSidebar() {
//     const sidebarHeight = sidebar.offsetHeight;
//     const stopRect = stopElement.getBoundingClientRect();

//     // Distance from top of viewport where sidebar bottom would be
//     const sidebarBottomPosition = topOffset + sidebarHeight;

//     // BEFORE reaching stop element
//     if (stopRect.top > sidebarBottomPosition) {
//       sidebar.style.position = "fixed";
//       sidebar.style.top = topOffset + "px";
//     } 
    
//     // WHEN reaching stop element
//     else {
//       sidebar.style.position = "static";
//       sidebar.style.top = "auto";
//     }
//   }

//   window.addEventListener("scroll", updateSidebar);
//   window.addEventListener("resize", updateSidebar);

//   updateSidebar();
// });
// ------------------------------------------------------------------------------------------------

// /* ============================= */
// /* APPLY DISCOUNT */
// /* ============================= */

// window.handleDiscountForm = async function(e) {

//   e.preventDefault();

//   const input = document.getElementById("CartDiscountInput");

//   const code = input.value.trim();

//   if (!code) return;

//   try {

//     /* Apply discount */
//     await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
//       method: "GET",
//       credentials: "same-origin"
//     });

//     /* Force Shopify cart refresh */
//     await fetch("/cart/update.js", {
//       method: "POST",
//       credentials: "same-origin",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({})
//     });

//     await refreshCartDiscount();

//   }

//   catch(err) {

//     console.error("Discount apply failed", err);

//   }

// };



// /* ============================= */
// /* REMOVE DISCOUNT */
// /* ============================= */

// window.removeDiscount = async function() {

//   try {

//     /* Apply fake code to clear discount */
//     await fetch(`/discount/INVALID?redirect=/cart`, {
//       method: "GET",
//       credentials: "same-origin"
//     });

//     /* Force refresh */
//     await fetch("/cart/update.js", {
//       method: "POST",
//       credentials: "same-origin",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({})
//     });

//     await refreshCartDiscount();

//   }

//   catch(err) {

//     console.error("Remove failed", err);

//   }

// };



// /* ============================= */
// /* REFRESH CART UI */
// /* ============================= */

// async function refreshCartDiscount() {

//   const res = await fetch("/cart.js", {
//     credentials: "same-origin",
//     cache: "no-store"
//   });

//   const cart = await res.json();



//   /* BADGE */

//   const badge = document.getElementById("CartDiscountBadge");

//   const badgeText = document.getElementById("AppliedDiscountCode");



//   if (cart.cart_level_discount_applications.length > 0) {

//     const discount = cart.cart_level_discount_applications[0];

//     badge.style.display = "flex";

//     badgeText.textContent =
//       `${discount.title} (-${formatMoney(cart.total_discount)})`;

//   }

//   else {

//     badge.style.display = "none";

//     badgeText.textContent = "";

//   }



//   /* TOTALS */

//   const subtotalEl = document.querySelector(".subtotal");

//   const discountEl = document.querySelector(".discount");

//   const totalEl = document.querySelector(".total");

//   const discountRow = document.querySelector(".discount-row");



//   if (subtotalEl)
//     subtotalEl.textContent =
//       formatMoney(cart.original_total_price);



//   if (discountEl)
//     discountEl.textContent =
//       formatMoney(cart.total_discount);



//   if (totalEl)
//     totalEl.textContent =
//       formatMoney(cart.total_price);



//   if (discountRow)
//     discountRow.style.display =
//       cart.total_discount > 0 ? "flex" : "none";

// }



// /* ============================= */
// /* AUTO SYNC */
// /* ============================= */

// document.addEventListener("DOMContentLoaded", refreshCartDiscount);

// document.addEventListener("visibilitychange", function(){

//   if(document.visibilityState === "visible"){

//     refreshCartDiscount();

//   }

// });